import React from "react";
import { useTranslation } from "../../translations/runtime";

export default function BackArrow({ size = 16 }) {
  const { isRTL } = useTranslation();
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d={isRTL
          ? "M9.24174 3.75736L12.89905 7.88889L9.24173 12.2426"
          : "M6.75826 3.75736L3.10095 7.88889L6.75827 12.2426"}
        stroke="black" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  );
}
